<template>
  <div class="app-blog-post">
    <hero-banner :title="bannerTitle"></hero-banner>

    <!-- Main content -->
    <div class="container my-5">
      <div class="row" v-if="contentLoaded">
        <div class="col-md-10 offset-md-2">
          <div class="post-details">
            <!-- <h6 class="d-block text-secondary mb-2">{{ postData.date_craeted }}</h6> -->

            <div class="post-img">
              <img :src="postData.image" alt class="shadow-lg" />
            </div>
            <div class="row">
              <div class="col-md-12" style="display:flex">
                <!-- bloginfo -->
                <div class="col-md-10">
                  <!-- blog description -->
                  <div class="bloginfo">
                    <h2 class=" blogTitle">{{ postData.title }}</h2>
                    <div class="post-content">
                      <div v-html="postData.description" class="desc"></div>
                    </div>
                    <div>
                      <div class="col-md-12">
                        <!-- <p class="sharethis">Share This Article</p>

                        <ShareFacebook
                          size="s"
                          style="margin-right:5px;"
                          url="http://lesley.tribalhousestudios.com/"
                        />
                        <ShareTwitter
                          size="s"
                          style="margin-right:5px;"
                          url="http://lesley.tribalhousestudios.com/"
                        /> -->
                        <!-- <ShareGooglePlus
                          size="s"
                          style="margin-right:5px;"
                          url="https://sheaglobaltrading.com/"
                        /> -->
                        <!-- <whats-app url="" title="Hello" scale="3"></whats-app> -->
                      
                      </div>
                    </div>
                  </div>
                  <!-- view more -->
                  <!-- <div
                    style="display:flex; padding:0.5rem 1rem; margin-top:2rem; margin-bottom:2rem;border:1px solid #55555533"
                  >
                    <div class="blogimages mt-3"></div>
                    <div class style="padding-left:1rem; padding-top:1rem">
                      <h6>Lesley’s London</h6>
                      <p
                        style="color:#979797; font-size:12px;letter-spacing: 0.56px;"
                      >View all post by Lesley’s London</p>
                    </div>
                  </div> -->
                  <!-- comment -->

                  <div class="comment-section">
                    <div class="post-comments my-5">
                      <div class="header blogTitle">
                        <h6>{{ postComments.length }} Comments on this article</h6>
                      </div>
                      <div
                        class="comment-data my-4"
                        v-for="(comment, i) in postComments"
                        :key="i"
                        style="margin-left: 0.5rem;"
                      >
                        <div style="display:flex;">
                          <div class="blogimages"></div>
                          <div class="commentDes" style="padding-left:1rem; width:90%; text-align:justify;">
                            <h6>{{ comment.name }}</h6>
                            <p style="font-size:13px; color:#666666">{{ comment.comment }}</p>
                          </div>
                        </div>

                        <div></div>
                      </div>
                    </div>

                    <div class="add-post-comment mt-3">
                      <div class="commenttitle mb-4">
                        <h5>Write A Comment</h5>
                      </div>

                      <div class="commentFormMsg"></div>

                      <form autocomplete="off">
                        <div class="form-group md-form">
                          <div class="row">
                            <div class="col-md-6">
                              <input
                                type="text"
                                name="name"
                                id="name"
                                class="form-control"
                                placeholder="Your Name"
                                v-validate="'required'"
                                v-model="userComment.name"
                              />
                              <span class="text-danger">{{ errors.first('name') }}</span>
                            </div>

                            <div class="col-md-6">
                              <input
                                type="email"
                                name="email"
                                id="email"
                                class="form-control"
                                placeholder="Email "
                                v-validate="'required|email'"
                                v-model="userComment.email"
                              />
                              <span class="text-danger">{{ errors.first('email') }}</span>
                            </div>
                            <div class="col-md-12">
                              <textarea
                                name="comment"
                                id="comment"
                                cols="20"
                                rows="3"
                                class="form-control"
                                placeholder=" Comment "
                                v-model="userComment.comment"
                                v-validate="'required'"
                                style="width: 100%;"
                              ></textarea>
                              <span class="text-danger">{{ errors.first('comment') }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-12">
                              <button
                                class="btn btn-block commentBtn"
                                v-on:click.prevent="addComment($event)"
                              >Submit Comment</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>

           
          </div>
        </div>
      </div>

      <div class="row" v-if="!contentLoaded">
        <div class="col-md-3">
          <div class="fake-post-item">
            <div class="fake-content animated-background mb-2"></div>
            <div class="fake-content animated-background mb-2"></div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="fake-post-item">
            <div class="fake-date animated-background mb-3"></div>

            <div class="fake-image animated-background mb-3"></div>

            <div class="fake-content animated-background mb-2"></div>
            <div class="fake-content animated-background mb-2"></div>
            <div class="fake-content animated-background mb-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import BlogSidebar from "../../components/BlogSidebar.vue";
import { WhatsApp } from "vue-socialmedia-share";
var blogImg = require("../../assets/img/blog.png");


var adminImg = require("../../assets/img/user.png");
var calenderImg = require("../../assets/img/calender.png");

import axios from "axios";

export default {
  components: {  blogsidebar: BlogSidebar },
  name: "Post",
  data() {
    return {
      postData: "",
      WhatsApp,
      postTitle: "",
      bannerTitle: "",
      postComments: [],
      categoryData: [],
     
      adminImg: adminImg,
      blogImg: blogImg,
     

      calenderImg: calenderImg,
      userComment: { name: "", email: "", comment: "" },
      contentLoaded: true
    };
  },
  metaInfo() {
    return {
      title: this.postData.title
    };
  },
  methods: {
    reply(e) {
      var e = $(".newset").addClass("disappear");
    },
    hidenext(e) {
      var e = $(".newset").removeClass("disappear");
    },
    addreply(e) {
      this.hidenext(e);
    },
    fetchProductCategories() {
      axios
        .get(APIURL + "categories")
        .then(response => {
          this.categoryData = response.data;
          console.log(this.categoryData);

          if (this.hasSubcategories) {
            this.subcategoryData = res.data.subcategories;
            //console.log(this.subcategoryData)
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    // Fetch post data
    fetchPostData() {
      var dash = this.$route.params.blogdash;
      var mask = this.$route.params.blogmask;

      if (dash && mask) {
        this.contentLoaded = false;

        axios
          .get(APIURL + "blog/" + dash + "/" + mask)
          .then(response => {
            var res = response.data;

            if (res.status == 200) {
              this.contentLoaded = true;
              this.postData = res.data;
              this.postComments = res.data.comments;
              this.bannerTitle = this.capitalizeEachWord(res.data.title);
            } else {
              this.$router.push({ name: "error404" });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$router.push({ name: "error404s" });
      }
    },

    //Add post comment
    addComment(e) {
      var btn = e.currentTarget;
      var sve = document.querySelector(".s-v-e");
      if (sve) {
        sve.remove();
      }
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            var mask = this.$route.params.blogmask;
            var requestData = JSON.stringify(this.userComment);
            btn.innerHtml = '<span class="fa fa-spin fa-spinner fa-fw"></span>';

            axios
              .post(APIURL + "addcomment/" + mask, requestData)
              .then(response => {
                var res = response.data;
                if (res.status == 200) {
                  btn.innerHtml = "Post Comment";
                  this.userComment = { email: "", name: "", comment: "" };
                  this.postComments.push(res.comment);
                  this.$validator.reset();
                } else {
                  if (res.status == 412) {
                    res.error.forEach((k, v) => {
                      document.querySelector("#" + k).after(v);
                    });
                  } else {
                    var html = `<div class="alert alert-warning alert-dismissible fade show" role="alert">
                                                    ${res.msg}
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>`;
                    document
                      .querySelector(".commentFormMsg")
                      .classList.add("mb-3");
                    document.querySelector(".commentFormMsg").innerHtml = html;
                  }
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    capitalizeEachWord(str) {
      var lower = String(str).toLowerCase();
      return lower.replace(/(^| )(\w)/g, function(x) {
        return x.toUpperCase();
      });
    }
  },
  created() {
    this.fetchPostData();
    this.fetchProductCategories();
  }
};
</script>
